import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "21",
  viewBox: "0 0 30 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.518 21C26.6502 21 30 17.6502 30 13.518L30 -1.90735e-06L7.48204 0C3.34982 0 0 3.34982 0 7.48204V21H22.518ZM14.5881 11.925C12.9009 11.925 11.6761 10.6333 11.6761 9.21251C11.6761 7.79175 12.9009 6.5 14.5881 6.5C16.2752 6.5 17.5 7.79175 17.5 9.21251C17.5 10.6333 16.2752 11.925 14.5881 11.925ZM14.5881 13.925C11.8753 13.925 9.67612 11.8152 9.67612 9.21251C9.67612 6.60986 11.8753 4.5 14.5881 4.5C17.3008 4.5 19.5 6.60986 19.5 9.21251C19.5 11.8152 17.3008 13.925 14.5881 13.925ZM24 18.25L6 18.25V16.25L24 16.25V18.25Z",
      fill: "#F7F7F7"
    }, null, -1)
  ])))
}
export default { render: render }